// ja strings for messages/nav.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const nav: Dict = {
  "nav.home": "ホーム",
  "nav.create": "作成",
  "nav.voices": "ボイス",
  "nav.train": "ボイスを学習",
  "nav.library": "ライブラリ",
  "nav.tab.profile": "プロフィール",
  "nav.404.seoTitle": "ページが見つかりません | Jammable",
  "nav.404.title": "ページが見つかりません",
  "nav.404.body": "このコンテンツは存在しないようです。",
  "nav.404.home": "ホームに戻る",
  "nav.404.browse": "ボイスを探す",
  "nav.404.discordLabel": "お探しのものがありますか？",
  "nav.404.discordBody": "Discordでコミュニティに質問する",
  "nav.pricing": "料金プラン",
  "nav.affiliate": "アフィリエイト",
  "nav.api": "API",
  "nav.login": "ログイン",
  "nav.signup": "新規登録",
  "nav.signupFree": "無料で登録",
  "nav.getPlan": "プランに登録",
  "nav.discordAria": "JammableのDiscordに参加",
  "nav.discordJoin": "Discordに参加",
  "nav.openMenu": "メニューを開く",
  "nav.closeMenu": "メニューを閉じる",

  // 0 morning, 1 afternoon, 2 evening, 3 late night.
  "nav.greet.0.0": "早起きですね",
  "nav.greet.0.1": "おはようございます",
  "nav.greet.0.2": "おはよう",
  "nav.greet.0.3": "やあ",
  "nav.greet.0.4": "調子はどう？",
  "nav.greet.1.0": "やあ",
  "nav.greet.1.1": "こんにちは",
  "nav.greet.1.2": "どうも",
  "nav.greet.1.3": "元気？",
  "nav.greet.1.4": "ようこそ",
  "nav.greet.2.0": "こんばんは",
  "nav.greet.2.1": "おつかれさま",
  "nav.greet.2.2": "今日はどうだった？",
  "nav.greet.2.3": "やあ",
  "nav.greet.2.4": "こんばんは！",
  "nav.greet.3.0": "まだ起きてる？",
  "nav.greet.3.1": "夜ふかしですね",
  "nav.greet.3.2": "夜型さん、こんばんは",
  "nav.greet.3.3": "眠れない？",
  "nav.greet.3.4": "深夜のひととき",
  "nav.profile.view": "プロフィールを見る",
  "nav.profile.credit": "クレジット",
  "nav.profile.credits": "クレジット",
  "nav.profile.voicePass": "Voice Pass",
  "nav.profile.voices": "ボイス",
  "nav.profile.shop": "アイテムショップ",
  "nav.profile.feedback": "フィードバックを送る",
  "nav.profile.settings": "設定",
  "nav.profile.apiDashboard": "APIダッシュボード",
  "nav.profile.signOut": "ログアウト",
  "nav.profile.signedOut": "ログアウトしました",
  "nav.profile.avatarAlt": "ユーザーのアバター",

  "nav.footer.tagline": "10万以上のボイスでAIカバー。数秒で作成できます。",
  "nav.footer.colCreate": "作成",
  "nav.footer.colAccount": "アカウント",
  "nav.footer.colLegal": "規約",
  "nav.footer.aiCover": "AIカバー作成",
  "nav.footer.voiceChanger": "AIボイスチェンジャー",
  "nav.footer.voiceLibrary": "AIボイスライブラリ",
  "nav.footer.train": "ボイスを学習",
  "nav.footer.weights": "Weights.ggの代替サービス",
  "nav.footer.settings": "設定",
  "nav.footer.earn": "Jammableで収益化",
  "nav.footer.mcp": "AIエージェント向けMCPサーバー",
  "nav.footer.forgot": "パスワードをお忘れの方",
  "nav.footer.terms": "利用規約",
  "nav.footer.privacy": "プライバシーポリシー",
  "nav.footer.dmca": "DMCAポリシー",
  "nav.footer.refunds": "返金ポリシー",
  // "<before> <link> <after>": 音声処理に [Pitchmeldの技術] を使用しています
  "nav.footer.pitchmeldBefore": "音声処理に",
  "nav.footer.pitchmeldLink": "Pitchmeldの技術",
  "nav.footer.pitchmeldAfter": "を使用しています",

  "nav.language": "言語",
};

export default nav;
